<div class="form form--address-short form--full-width" [ngClass]="getLevelClass()">
  <div class="form__label">
    <basic-label [noIndent]="true"></basic-label>
  </div>

  <div class="form__inline-field-container">
    <div class="form__field">
      <label *ngIf="isServer" class="entry-field__label">City</label>
      <basic-text-input [propertyName]="cityProp" [hideLabel]="true" [placeholder]="'City'"></basic-text-input>
    </div>

    <div class="form__field">
      <label *ngIf="isServer" class="entry-field__label">State</label>
      <select-basic [property]="stateProp" [showTitle]="false"></select-basic>
    </div>
  </div>
</div>
